
import FullColoredCard from "./FullColoredCard";
import { IMeters } from "../../../serviceOrdering/interfaces/ServiceReport.ts";

export interface MetersTileComponentProps {
  meters: IMeters;
}

const MetersTileComponent = ({ meters }: MetersTileComponentProps) => {
  return (
    <div className="dwelling_meters">
      {Object.entries(meters).map(([key, meter], index) => (
        <FullColoredCard key={index} meter={meter} type={key} />
      ))}
    </div>
  );
};

export default MetersTileComponent;
